import { stripQuery } from '@/lib/string';
import tectoastr from '@/lib/tectoastr';
import { trans } from '@/domain/dao/Translations';
import { useApi } from './VideoThumbnailSelector.api';
import { VideoThumbnailEvents } from '@/lib/components/Uploader/VideoThumbnailModal.events';
import { Ref, toRef } from 'vue';

type Props = {
	thumbnails: string[];
	value: string | null;
	fileToken: string;
};

type View = {
	thumbnails: Ref<string[]>;
	select: (thumb: string) => Promise<void>;
	isSelected: (thumb: string) => boolean;
};

const videoThumbnailSelectorController = (props: Props, ctx: { emit: (event: string, val: string) => void }): View => {
	const { selectThumbnail } = useApi(props.fileToken);
	const thumbnails = toRef(props, 'thumbnails');

	const select = async (thumb: string) => {
		try {
			await selectThumbnail(thumb);
			ctx.emit(VideoThumbnailEvents.ThumbnailSelected, thumb);
		} catch (error) {
			tectoastr.error(trans().get('media.messages.select_thumbnail_error'));
		}
	};

	const isSelected = (thumb: string) => stripQuery(thumb) === stripQuery(props.value);

	return {
		thumbnails,
		select,
		isSelected,
	};
};

export { videoThumbnailSelectorController };
